import { useAuth } from '@/contexts/auth-context';
import { useBrandSpaceHomeQuery } from '@/hooks/queries/use-brand-space-home-query';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NavTag from '../nav-bar/components/NavTag';

/**
 * "Live" pill on the Brand Space row of the sidebar footer.
 *
 * The pill's entire informational value is the published/not distinction, so it
 * renders nothing while the space is a draft, archived, or not provisioned yet.
 * A permanent "Live" would state something false for every brand that has not
 * published.
 *
 * It reads the query the Brand Space pages already use, so the call is shared:
 * deduplicated by key, cached for a minute, and it leaves the home page warm on
 * arrival. It only fires for a brand manager with an active brand, since that is
 * the only case where this row renders at all.
 */
const BrandSpaceLiveBadge: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { data } = useBrandSpaceHomeQuery(user?.currentBrandId ?? null);

  if (data?.space?.status !== 'published') return null;

  return <NavTag tone="live">{t('navigation.brandSpaceLive')}</NavTag>;
};

export default BrandSpaceLiveBadge;
